import{a as r}from"./chunk-46MFRMGF.mjs";import{a as o}from"./chunk-7RJG5BRD.mjs";import{Fragment as m,jsx as t}from"react/jsx-runtime";function C(n){return t(m,{children:t(r,o({},n))})}export{C as a};
